// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-PrimaryButton----index-module---root---26r5E","rootInverted":"src-components-PrimaryButton----index-module---rootInverted---b94Xu src-components-PrimaryButton----index-module---root---26r5E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrimaryButton/index.module.css
// module id = 615
// module chunks = 168707334958949